import type { DeepPartial } from '@luna/utils-ts';

import type { Misc } from '../../types/Misc';

export const miscCZFeatureConfig: DeepPartial<Misc> = {
    addTokenToDownloadPayload: true,
};
